import { Component } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { LoginService } from 'src/app/core/login/login.service';
import { SnackBarService } from 'src/app/core/services/snackbar.service';
import { ComponentWithLoadingState } from '../component-with-loading-state/component-with-loading-state';
import { finalize } from 'rxjs/operators';
import { ServerErrorUtils } from '../../utils/server-error-utils';
import { MyErrorStateMatcher } from '../../domain/shared.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'ctv-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss']
})
export class ChangePasswordDialogComponent extends ComponentWithLoadingState {
  public oldPassword: string;
  public newPassword: string;
  public confirmPassword: string;
  public readonly errorStateMatcher = new MyErrorStateMatcher();

  public form = new FormGroup({
    oldPassword: new FormControl<string>('', Validators.required),
    newPassword: new FormControl<string>('', [Validators.required, RxwebValidators.password({validation:{minLength: 8, digit: true,specialCharacter: true, upperCase: true}})]),
    confirmPassword: new FormControl<string>('', [Validators.required, RxwebValidators.password({validation:{minLength: 8, digit: true,specialCharacter: true, upperCase: true}}), RxwebValidators.compare({fieldName: 'newPassword'})])
  });

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    private readonly snackBarService: SnackBarService,
    private readonly loginService: LoginService,
  ) {
    super();
    this.dialogRef.updateSize('580px');
  }

  public save() {
    this._loading$.next(true);
    this.loginService.changePassword(this.form.getRawValue())
      .pipe(
        finalize(() => this._loading$.next(false))
      )
      .subscribe(
        (data) => {
          this.snackBarService.success('Successfully changed password');
          this.dialogRef.close();
        },
        (error) => {
          const messages = ServerErrorUtils.getValidationMessages(error);
          if (messages) {
            messages.forEach(m => this.snackBarService.error(m));
          } else {
            this.snackBarService.error('Error while trying to set new password.');
          }
        }
      );
  }
}
